(function ($) {
  $(document).ready(function () {
    const customerId = window.theme.customerId;
    if ($('#shopify-section-cart-template').length && customerId) {
      ajaxCart('cart');
    }

    if (['contact_information', 'payment_method', 'shipping_method'].includes($(".main .step").attr("data-step"))) {
      if ($('.checkout-template.content').length) {
        setTimeout(function () {
          ajaxCart('checkout');
        }, 1000);
      }
    }


    function ajaxCart(type) {
      if (type == 'cart') {
        $('.cart__checkout-button').attr('disabled', 'disabled');
      }

      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function (cart) {
          let arrProduct = [];
          if (cart.item_count > 0) {
            cart.items.map(function (item) {
              arrProduct.push({ id: item.product_id, variant_id: item.variant_id, qty: item.quantity });
            })

            callAPIWithTokenRefresh(`customers/${customerId}/orders/purchasing/validate`, 'post', { 'products': arrProduct })
              .then(function (res) {
                if (!res.status) {
                  if (type == 'cart') {
                    $('.cart__checkout-button').removeAttr("disabled");
                    $('.cart__checkout-button').attr('type', 'button');
                    $('.cart__checkout-button').on('click', function () {
                      alert(res.message);
                    })
                    res.data.products.map(function (item) {
                      if (!item.status) {
                        const eleError_Msg = $(`[data-variant-id="${item.variant_id}"]`).find('.error_Msg.not_update');
                        eleError_Msg.css('display', 'block');
                        eleError_Msg.text('Item sold out.');
                      }
                    })

                  } else {
                    $('#continue_button').attr('disabled', 'disabled');
                    $('#continue_button').attr('type', 'button');
                    let mesAlert = 'Some products are out of stock. Back to cart page?';
                    if (res.message != 'OUT_OF_STOCK') {
                      mesAlert = res.message;
                    }
                    if (window.confirm(mesAlert)) {
                      window.location.href = '/cart';
                    }
                  }
                } else {
                  $('.cart__checkout-button').removeAttr('disabled');
                }
              })
              .catch(function () {
              })
          }
        }
      })
    }
  })

}(jQuery));


